export default {
      id: "button-kakao-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#button-kakao",
      toString: function () {
        return this.url;
      }
    }